<template>
  <div class="quantity-handler d-flex flex-row justify-center">
    <BaseButton
      :disabled="isAvailable"
      @click="$emit('on-sub')"
      height="30"
      width="30"
      color="black"
      class="mr-2"
      ref="sub"
      x-small
      variant="black"
    >
      <v-icon size="18">$minus</v-icon>
    </BaseButton>
    <BaseTextField
      v-model="quantityHandler"
      hide-details
      single-line
      type="number"
      class="text-field mr-2"
      @input="changeQuantity"
    />
    <BaseButton
      :disabled="isAvailable"
      @click="$emit('on-add')"
      height="30"
      width="28"
      color="black"
      ref="plus"
      x-small
      variant="black"
    >
      <v-icon size="18">$plus</v-icon>
    </BaseButton>
  </div>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";

export default {
  name: "QuantityHandler",
  components: {
    BaseTextField,
    BaseButton,
  },
  data() {
    return {
      quantitySoft: 0,
    };
  },
  props: {
    quantity: {
      type: Number,
    },
    softQuantity: {
      type: Number,
    },
    isAvailable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    quantityHandler: {
      get() {
        return this.quantity;
      },
      set(value) {
        this.quantitySoft = value;
        return Number(this.quantitySoft);
      },
    },
  },
  methods: {
    changeQuantity() {
      this.$emit("on-change", Number(this.quantitySoft));
    },
  },
};
</script>
<style>
.quantity-handler {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qtd-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 35px !important;
  max-height: 35px !important;
  min-width: 36px !important;
  width: 100%;
}
.text-field input {
  text-align: center !important;
}
</style>
